import { handleActions } from 'redux-actions';
import actions from './actions';

export const initialState = {
  publishedEvent: {
    isFetching: false,
    eventToUpdate: undefined
  },
  events: {
    eventsResult: {
      events: [],
      total: 0,
      hits: 0,
      take: 0,
      skip: 0
    },
    selectedEvent: null,
    isFetching: false,
    isLoadingMore: false,
    error: null
  }
};

const extendState = (state, newState) => ({
  ...state,
  events: {
    ...state.events,
    ...newState
  }
});

export const reducerDefinition = {
  [actions.publisherPortal.publishedEvent.api.addPublishedEvent.request]: (state, action) => ({
    ...state,
    publishedEvent: {
      ...state.publishedEvent,
      isFetching: true
    }
  }),
  [actions.publisherPortal.publishedEvent.api.addPublishedEvent.success]: (state, action) => ({
    ...state,
    publishedEvent: {
      ...state.publishedEvent,
      isFetching: false
    }
  }),
  [actions.publisherPortal.publishedEvent.api.updatePublishedEvent.request]: (state, action) => ({
    ...state,
    publishedEvent: {
      ...state.publishedEvent,
      isFetching: true
    }
  }),
  [actions.publisherPortal.publishedEvent.api.updatePublishedEvent.success]: (state, action) => ({
    ...state,
    publishedEvent: {
      ...state.publishedEvent,
      isFetching: false
    },
  }),
  [actions.publisherPortal.publishedEvent.api.getPublishedEventById.success]: (state, action) => ({
    ...state,
    publishedEvent: {
      ...state.publishedEvent,
      eventToUpdate: action.payload['published-event']
    }
  }),
  [actions.publisherPortal.publishedEvent.api.get.request]: (state, action) =>
    extendState(state, {
      isFetching: true
    }),
  [actions.publisherPortal.publishedEvent.api.get.success]: (state, action) =>
    extendState(state, {
      isFetching: false,
      eventsResult: action.payload.eventsResult,
      error: null
    })
};

export default handleActions(reducerDefinition, { ...initialState });



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/published-event/reducers.js